import { BaseCanvasPack } from "./BaseCanvasPack";

export default class NeonGridCanvasPack extends BaseCanvasPack {
  drawBackground(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number,
    level?: number
  ): void {
    context.fillStyle = "#020b16";
    context.fillRect(0, 0, width, height);

    if (frameTime !== undefined) {
      this.drawGrid(context, width, height, frameTime);
    }
  }

  drawFrame(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {

    // Neon border
    const borderWidth = 2;
    context.shadowBlur = 10;
    context.shadowColor = "#00FF00";
    context.strokeStyle = "#00FF00";
    context.lineWidth = borderWidth;
    context.strokeRect(0.5, 0.5, width - 1, height - 1);
    context.shadowBlur = 0;
  }

  drawOverlay(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime?: number
  ): void {
    if (frameTime !== undefined) {
      this.drawBinaryStreams(context, width, height, frameTime);
      this.drawScanline(context, width, height, frameTime);
    }
  }

  private drawGrid(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    context.strokeStyle = "rgba(0, 255, 0, 0.2)";
    context.lineWidth = 1;
    
    const gridSize = 30;
    const offset = (frameTime * 0.02) % gridSize;
    
    // Vertical lines
    for (let x = 0; x <= width; x += gridSize) {
      context.beginPath();
      context.moveTo(x, 0);
      context.lineTo(x, height);
      context.stroke();
    }
    
    // Horizontal lines (moving down)
    for (let y = offset - gridSize; y <= height; y += gridSize) {
      context.beginPath();
      context.moveTo(0, y);
      context.lineTo(width, y);
      context.stroke();
    }
    
    context.restore();
  }

  private drawBinaryStreams(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    context.fillStyle = "rgba(0, 255, 0, 0.5)";
    context.font = "10px monospace";
    
    const columns = Math.floor(width / 20);
    for (let i = 0; i < columns; i++) {
      // Only draw some columns
      if (i % 3 !== 0) continue;
      
      const speed = 0.05 + (i % 5) * 0.01;
      const y = (frameTime * speed + i * 100) % (height + 100) - 20;
      
      // Draw a trail of characters
      for (let j = 0; j < 5; j++) {
        const char = Math.random() > 0.5 ? "1" : "0";
        context.globalAlpha = 0.5 - j * 0.1;
        context.fillText(char, i * 20, y - j * 12);
      }
    }
    context.restore();
  }

  private drawScanline(
    context: CanvasRenderingContext2D,
    width: number,
    height: number,
    frameTime: number
  ): void {
    context.save();
    const y = (frameTime * 0.1) % height;
    
    context.fillStyle = "rgba(0, 255, 0, 0.1)";
    context.fillRect(0, y, width, 5);
    
    context.restore();
  }

  getBorderStyle(): string {
    return "2px solid #00FF00";
  }

  getBoxShadow(frameTime?: number): string {
    return "0 0 15px #00FF00";
  }

  getBackdropFilter(): string {
    return "none";
  }
}

